import { render, staticRenderFns } from "./BuildingDetailNotes.vue?vue&type=template&id=dd773110"
import script from "./BuildingDetailNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingDetailNotes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports